export interface SyncViewState { linked:boolean; online:boolean; checking:boolean; waiting:boolean; pending:boolean; conflicts:number; error:string; lastSuccessfulAt:number | null }
export function syncStateLabel(state:SyncViewState):string {
  if(state.checking)return 'Синхронизация…';
  if(!state.online)return 'Нет сети. Записи сохраняются на устройстве.';
  if(state.conflicts>0)return `Есть несовпадения: ${state.conflicts}. Требуется ваш выбор.`;
  if(state.error)return 'Последняя попытка не завершилась. Приложение повторит её автоматически.';
  if(!state.linked)return 'Ожидание первой автоматической синхронизации.';
  if(state.waiting)return 'Полученные изменения ожидают завершения редактирования.';
  if(state.pending)return 'Есть изменения, ожидающие отправки.';
  if(state.lastSuccessfulAt===null)return 'Время успешной синхронизации пока неизвестно.';
  return 'Последний обмен завершён. Новые записи отправляются автоматически.';
}
export function formatSyncDate(at:number):string {
  return new Intl.DateTimeFormat('ru-RU',{dateStyle:'short',timeStyle:'short'}).format(new Date(at));
}
